import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ApplicationStore } from '@core/stores/application.store';

export const AdminGuard: CanActivateFn = () => {
  const applicationStore = inject(ApplicationStore);
  const router = inject(Router);

  if (applicationStore.isAdmin()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
